<template>
  <v-dialog :value="true" persistent max-width="800" @keydown.esc="handleModalClose">
    <app-spinner v-if="loading" :spinner-size="80" class="spinner-background" />

    <v-card>
      <v-card-text class="pb-0 pt-8">
        <v-row>
          <v-col cols="4" align="center" justify="center" class="grow">
            <h5 class="color light-gray text-uppercase opacity-50 ml-3">
              <v-img :src="getProofIcon" aspect-ratio="1" height="24" width="24" class="p-0 mr-1 d-inline-flex" />
              <span class="text-uppercase"> {{ proof.proof_type | prettyProofType }} </span>
            </h5>
            <ScreenShotPost v-if="proof.img_url" :img-url="proof.img_url" :message-content="proof.message_content" classes="" />
          </v-col>
          <v-col cols="8">
            <v-row align="center" justify="center" class="mt-0">
              <v-col cols="3" align="center" justify="center">
                <v-icon large class="pa-0 ma-0 mt-n4">mdi-account-circle-outline</v-icon>
                <span class="overline d-block">local</span>
              </v-col>
              <v-col cols="9" align="left" justify="center">
                <h1>{{ user.first_name }}</h1>
                <p class="font-weight-light caption mt-2 ml-6 mb-0">joined us on {{ user.created_at | prettyDate }}</p>
                <p class="font-weight-light caption ml-6 mt-0">posts shared: {{ proof_num }}</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-0">
              <v-col cols="3" align="center" justify="center">
                <VueApexCharts :options="data" :series="data.series" />
              </v-col>
              <v-col cols="9" align="left" justify="center">
                <p class="caption mb-0">
                  On <strong>{{ proof.proof_date | prettyDate }}</strong
                  >, {{ user.first_name || 'Local' }} visited your location and she provided this proof on <strong>{{ proof.proof_date | prettyDate }}</strong
                  >. They were the <span class="ticket-color font-weight-bold">6th of 10</span> customers to visit and this proof is the
                  <span class="post-color font-weight-bold">4th of 10.</span>
                </p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-0">
              <v-col cols="3" align="center" justify="center">
                <v-icon large class="pa-0 ma-0 block">mdi-offer</v-icon>
                <span class="overline d-block">offer</span>
              </v-col>
              <v-col cols="9" align="left" justify="center">
                <v-row>
                  <v-col cols="12">
                    <span class="title-2 mb-0">{{ offer.offer_summary }}</span>
                  </v-col>
                </v-row>
                <h5 class="color light-gray text-uppercase opacity-50"></h5>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-0">
              <v-col cols="3" align="center" justify="center">
                <p :class="['text-h4', 'font-weight-medium', 'mb-0', colorFromProofType].join(' ')">${{ amount }}</p>
                <span :class="['overline', 'd-block', colorFromProofType].join(' ')">value</span>
              </v-col>
              <v-col cols="9" align="left" justify="center" class="pa-0">
                <h5 class="color light-gray text-uppercase opacity-50 ml-3">
                  <v-img :src="getProofIcon" aspect-ratio="1" height="24" width="24" class="p-0 mr-1 d-inline-flex" />
                  <span class="text-uppercase"> {{ proof.proof_type | prettyProofType }} </span>
                </h5>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-0">
              <v-col cols="3" align="center" justify="center">
                <v-icon large class="pa-0 ma-0 block">mdi-comment-quote-outline</v-icon>
                <span class="overline d-block">feedback</span>
              </v-col>
              <v-col cols="9" align="left" justify="center">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      v-if="!proof.client_feedback_app_user_id"
                      fab
                      x-small
                      elevation="3"
                      color="#539FDB"
                      class="client-feedback-button"
                      @click="showProofFeedbackModal = true"
                    >
                      <v-icon color="white">mdi-chat-plus</v-icon>
                    </v-btn>
                    <div v-else>
                      <span v-for="fb in proof.client_feedback" :key="fb" class="ml-4">
                        <v-icon>{{ iconForType(fb) }}</v-icon> {{ fb | prettyProofFeedback }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <h5 class="color light-gray text-uppercase opacity-50"></h5>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text @click="handleModalClose">Close</v-btn>
        <!-- <v-btn :loading="false" color="primary darken-1" text @click="handleModalClose">Feedback</v-btn> -->
      </v-card-actions>
    </v-card>

    <ProofFeedbackModal v-if="showProofFeedbackModal" :proof="proofWithUser" @proof-feedback-modal-close="handleFeedbackClose" />
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import taskTypes from '../../models/taskType'

import { ApiService } from '@/services/index'
import { ProofFeedback } from '@/models/Proof'

import ScreenShotPost from '@/components/ProofCardList/ProofCardContent/ScreenShotPost'
import ProofFeedbackModal from '@/components/ProofCardList/ProofFeedbackModal'
import VueApexCharts from 'vue-apexcharts'

export default Vue.extend({
  name: 'ProofDetailModal',
  components: {
    ScreenShotPost,
    ProofFeedbackModal,
    VueApexCharts,
  },
  props: {
    proofId: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    user: {},
    proof: {},
    offer: {},
    voucher: {},
    proof_num: null,
    loading: false,
    showProofFeedbackModal: false,
  }),
  computed: {
    proofWithUser() {
      return { ...this.proof, influencer: { ...this.user } }
    },
    feedbackTypes() {
      return Object.values(ProofFeedback)
    },

    colorFromProofType() {
      if (this.proof.proof_type && this.proof.proof_type.toLowerCase().includes('review')) return 'review-color'
      return 'post-color'
    },
    data: function () {
      return {
        chart: {
          type: 'radialBar',
        },
        colors: ['#98E3F8', '#1F487E'],
        series: [0.5 * 100, 0.4 * 100],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
              image: undefined,
            },
            track: {
              show: true,
            },
            dataLabels: {
              name: {
                show: true,
              },
              value: {
                show: true,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['Redeems', 'Posts'],
      }
    },
    getProofIcon() {
      if (!this.proof.proof_type) return require('@/assets/svg/localfluence.svg')

      const proofType = taskTypes[this.proof.proof_type]
      return proofType ? proofType.icon : ''
    },
  },
  mounted: function () {
    ApiService.get(`dashboard/proofDetails/${this.proofId}`).then((response) => {
      this.user = response.data.user
      this.proof = response.data.proof
      this.offer = response.data.offer
      this.voucher = response.data.voucher
      this.proof_num = response.data.proof_num
      this.loading = false
    })
  },

  methods: {
    handleModalClose() {
      this.$emit('proof-modal-close')
    },
    handleFeedbackClose() {
      this.showProofFeedbackModal = false
      ApiService.get(`dashboard/proofDetails/${this.proofId}`).then((response) => {
        this.user = response.data.user
        this.proof = response.data.proof
        this.offer = response.data.offer
        this.voucher = response.data.voucher
        this.proof_num = response.data.proof_num
        this.loading = false
      })
    },
    iconForType(fb) {
      return ProofFeedback[fb].icon
    },
  },
})
</script>

<style scoped>
.review-color {
  color: #98e3f8 !important;
}

.post-color {
  color: #1f487e !important;
}

.ticket-color {
  color: #376996 !important;
}

.border {
  border: thin solid #cccccc;
}
</style>
